export class RecordingDoesNotHaveRequestedTimecodesError extends Error {
  constructor() {
    super('Cannot share this recording with the time range provided. Please select a different time range.')
    Object.setPrototypeOf(this, RecordingDoesNotHaveRequestedTimecodesError.prototype)
  }
}
